import { formatPercentageRange } from "~/utils/formatRange";

import type { IActivityFilter24hValue } from "./constants";

// the form works in whole percents; stored filter values use 0–1 fractions
export const toStoredActivityFilterValue = (
  formValue: IActivityFilter24hValue
): IActivityFilter24hValue => ({
  minVolume24h: formValue.minVolume24h,
  minPriceChange24h:
    formValue.minPriceChange24h != null
      ? formValue.minPriceChange24h / 100
      : undefined,
  maxPriceChange24h:
    formValue.maxPriceChange24h != null
      ? formValue.maxPriceChange24h / 100
      : undefined,
});

export const getMinVolumeLabel = (
  value: IActivityFilter24hValue
): string | null =>
  value.minVolume24h != null
    ? `Min 24h Volume: From ${value.minVolume24h.toLocaleString("en-US")}`
    : null;

export const getPriceChangeLabel = (
  value: IActivityFilter24hValue
): string | null =>
  formatPercentageRange(
    {
      min: value.minPriceChange24h,
      max: value.maxPriceChange24h,
    },
    false
  );
